import { makeStyles } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { ReactElement, useState } from 'react';
import { Venture } from '../../api/ventures/types/Venture';
import { CreateSchedulingWizardModal } from './create-scheduling-wizard-modal';
import { Button } from './index';

const useStyles = makeStyles(() => ({
  buttonScheduling: {
    minWidth: 102,
  },
}));

export interface Props {
  venture?: Venture;
}

export function CreateSchedulingWizardButton({ venture }: Props): ReactElement {
  const classes = useStyles();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {isOpen && venture && (
        <CreateSchedulingWizardModal
          venture={venture}
          onClose={() => setIsOpen(false)}
        />
      )}
      <Button
        onClick={() => setIsOpen(true)}
        variant='contained'
        data-testid='button-invite-all'
        className={classes.buttonScheduling}
        startIcon={<AddIcon />}>
        Wizard
      </Button>
    </>
  );
}
